import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import download1Image from "../../assests/images/download (1).png";
import trophyImage from "../../assests/images/rank-trophy.png";
import msgIco from "../../assests/images/msg-ico.png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import checkImage from "../../assests/images/check-circle.png";
import { strToDate } from "../../constant";
import { styled } from "@mui/material/styles";
import { rfqServices } from "../../services/rfqServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { onboardingServices } from "../../services/onboardingServices";
import _ from "lodash";
import { isEmptyDash } from "../../constant";
import RfqExtendValidaityModal from "../common/rfqExtendValidaityModal";
import SupportChat from "../support/chat";
import { UserObj } from "../../services/localStarage";
import Tooltip from '@mui/material/Tooltip';

import back from "../../assests/images/back.png";

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const StyledRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "#ff6d75",
  },
  "& .MuiRating-iconHover": {
    color: "#ff3d47",
  },
});
function EvaluationTechnical() {
  const { id } = useParams();
  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };
  const [value, setValue] = React.useState(2);
  const [isLoading, setIsLoading] = useState(false);
  const [openfinalizeevaluation, setOpenFinalizeEvaluation] = useState(false);
  const [opnextendvalidtymodal, setOpnExtendValidtyModal] = useState(false);
  const [rfqNumber, setRfqNumber] = useState('');
  const [currentRfqValidity, setCurrentRfqValidity] = useState({ from: "", to: "" });
  const [newValidityPeriod, setNewValidityPeriod] = useState("");
  const [currentValidityPeriod, setCurrentValidityPeriod] = useState("");
  const [newRfqValidity, setNewRfqValidity] = useState({ from: "", to: "" });
  const [rfqDetails, setRfqDetails] = React.useState({
    boqs: [],
    documents: [],
    rounds: [],
    rfqVendors: [],
    rfqValidity: { "from": null, "to": null },
  });

  const [
    openfinalizeevaluationsuccessfully,
    setOpenFinalizeEvaluationSuccessfully,
  ] = useState(false);
  const [openapprovefinalize, setOpenApproveFinalize] = useState(false);
  const [approvalObj, setApprovalObj] = useState({});
  const [finalizeObj, setFinalizeObj] = useState({});
  const [openvendorattingtechnical, setOpenVendoRattingTechnical] =
    useState(false);
  const [openvendorsuccessfullytechnical, setOpenVendorSuccessfullyTechnical] =
    useState(false);
  const [techEvaluationDetails, setTechEvaluationDetails] = React.useState({
    boqs: [],
    rfqVendors: [],
  });
  const [activeChatVendorId, setActiveChatVendorId] = useState("");
  const [opencreaterfqnewtoggler, setOpenCreateRfqnewToggler] =
    useState("AgainstPackage");

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    getTechnicalComparison(id);
    getRFQDetails(id);
  }, []);


  const getRFQDetails = (param) => {
    setIsLoading(true);
    let data = `/${param}`;
    let promise = rfqServices.getRfqListing(data);

    promise.then((res) => {
      if (res.data.success === true) {
        setRfqDetails(res.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getTechnicalComparison = (param) => {
    setIsLoading(true);
    let promise = rfqServices.getTechnicalComparison(param);

    promise.then((res) => {
      if (res.data.success === true) {
        let resData = res.data.data;
        // resData["boqTableArr"] = createTableArr(res.data.data);
        setActiveChatVendorId(resData?.rfqVendors?.[0]?.vendorId);
        setTechEvaluationDetails(resData);
        // setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getRfqVendorBoqByBoqId = (boqId, rfqVendorsBoqsArr) => {
    let obj = {};
    for (let i = 0; i < rfqVendorsBoqsArr.length; i++) {
      if (boqId == rfqVendorsBoqsArr[i]?.boqId) {
        obj["data"] = rfqVendorsBoqsArr[i];
        obj["index"] = i;
      }
    }
    return obj;
  }

  const downloadAttachment = (data, fileNameParam, secName, vendorIndex, attachmentIndex) => {
    setIsLoading(true);
    onboardingServices.viewUrlData(data).then(function (response) {
      const url = response?.data?.data?.url;
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileNameParam;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          let techEvaluationDetailsInit = _.cloneDeep(techEvaluationDetails);
          techEvaluationDetailsInit.rfqVendors[vendorIndex][secName][attachmentIndex].isChecked = true;
          setTechEvaluationDetails(techEvaluationDetailsInit);
        })
        .catch(error => console.error('Error downloading Doc:', error))
        .finally((param) => {
          setIsLoading(false);
        });
    });
  }

  const isAllElementChecked = (keyName, arr) => {
    let isAllChecked = true;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][keyName] != true) {
        isAllChecked = false;
      }
    }
    return isAllChecked;
  }

  const onApproval = (param, vendorData) => {
    if (isAllElementChecked("isChecked", techEvaluationDetails?.rfqVendors[vendorData?.index]?.tendorDrawing) && isAllElementChecked("isChecked", techEvaluationDetails?.rfqVendors[vendorData?.index]?.technicalSpecification)) {
      setApprovalObj({ param, vendorData });
      setOpenApproveFinalize(true);
    } else {
      setApprovalObj({});
      setAlertComponent({ open: true, type: "error", message: `Please download all attachment.` });
    }
  }

  const onRatingChange = (e) => {
    let { name, value } = e.target;
    setApprovalObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }


  const onRatingSubmit = (e) => {
    if (isEmptyDash(approvalObj?.feedback) || isEmptyDash(approvalObj?.rating)) {
      setAlertComponent({ open: true, type: "error", message: `Please fill all required fields. ` });
      return;
    }

    setIsLoading(true);
    let bodyData = {
      "status": approvalObj?.param, // "Approved",
      "feedback": approvalObj?.feedback, // "Very good",
      "rating": approvalObj?.rating, // 4,
      "vendorId": approvalObj?.vendorData?.vendorId, // "65e1c94de60f29f8bb2a4641",
      "rfqId": id,
    };
    let promise = rfqServices.techEvaluation(bodyData);

    promise.then((res) => {
      if (res.data.success === true) {

        setTechEvaluationDetails(prevState => {
          const updatedVendors = prevState.rfqVendors.map((vendor, index) => {
            if (index === approvalObj?.vendorData?.index) {
              return {
                ...vendor,
                technicalStatus: approvalObj?.param,
              };
            }
            return vendor;
          });
          return {
            ...prevState,
            rfqVendors: updatedVendors,
          };
        });

        setOpenVendorSuccessfullyTechnical(true);
        setOpenVendoRattingTechnical(false);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }


  const onFinalizeEvaluationInit = () => {
    let pendingVendors = techEvaluationDetails?.rfqVendors?.filter((ele, i) => ele?.technicalStatus == "Pending");
    let rejectedVendors = techEvaluationDetails?.rfqVendors?.filter((ele, i) => ele?.technicalStatus == "Rejected");
    let approvedVendors = techEvaluationDetails?.rfqVendors?.filter((ele, i) => ele?.technicalStatus == "Approved");

    if (pendingVendors?.length > 0) {
      setAlertComponent({ open: true, type: "error", message: `Kindly perform actions on all vendors below before finalizing evaluation. ` });
      return;
    } else {
      let obj = {
        rejectedVendors,
        approvedVendors,
      }
      setFinalizeObj(obj);
      setOpenFinalizeEvaluation(true);
    }
  }
  const [showFinalizeConfirmation, setShowFinalizeConfirmation] = useState(false);
  const onFinalizeSubmit = (e) => {
    setIsLoading(true);
    let bodyData = {
      "type": "Technical",
      "round": 1
    };
    let promise = rfqServices.techFinalize(id, bodyData);

    promise.then((res) => {
      if (res.data.success === true) {
        setOpenFinalizeEvaluation(false);
        setOpenFinalizeEvaluationSuccessfully(true);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const onExtendValidity = (boqId, rfqVendorsBoqsArr) => {
    setRfqNumber(rfqDetails?.rfqNumber);
    const dateString = rfqDetails?.rfqValidity?.from;
    const date = new Date(dateString);
    date.setHours(0, 0, 0, 0);
    const fromDate = date.toISOString().split('T')[0];

    const datetoString = rfqDetails?.rfqValidity?.to;
    const toDate = new Date(datetoString);
    toDate.setHours(0, 0, 0, 0);
    const toDDate = toDate.toISOString().split('T')[0];

    setCurrentRfqValidity({
      from: fromDate,
      to: toDDate
    })
    setOpnExtendValidtyModal(true);
  }

  const handleNewDatePickerChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      setNewRfqValidity({
        from: dateStrings[0],
        to: dateStrings[1]
      });

      const fromDate = new Date(dateStrings[0]);
      const toDate = new Date(dateStrings[1]);
      const differenceInTime = toDate.getTime() - fromDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      if (differenceInDays < 30) {
        setNewValidityPeriod(`${differenceInDays} Days`);
      } else {
        const differenceInMonths = differenceInDays / 30;
        const differenceInYears = differenceInMonths / 12;
        setNewValidityPeriod(`${differenceInYears.toFixed(1)} Years`);
      }
    }
  };
  function formatFileName(fileName, maxLength = 10) {
    if (!fileName || typeof fileName !== 'string') {
      return '';
    }
    if (fileName.length <= maxLength) {
      return fileName;
    }
    const startLength = Math.ceil(maxLength / 2);
    const endLength = Math.floor(maxLength / 2) - 3;
    const startText = fileName.substring(0, startLength);
    const endText = fileName.substring(fileName.length - endLength);
    return `${startText}...${endText}`;
  }
  const closeExtendValidty = () => {
    setOpnExtendValidtyModal(false);
    setNewValidityPeriod('');
  }

  const redirectToListing = () => {
    navigateUrl("/admin/Engineering-Bidding-Rfq-Listing");
  }

  const handleSubmit = () => {
    setIsLoading(true);
    let bodydata = {
      "rfqValidity": { from: newRfqValidity.from, to: newRfqValidity.to },
      "rfqNumber": rfqNumber,
    }
    let reqId = id;
    if (reqId) {
      rfqServices.extendValidity(reqId, bodydata)
        .then((res) => {
          if (res && res.data) {
            setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
            setOpnExtendValidtyModal(false);
            setNewValidityPeriod('');
            window.location.reload();
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          setAlertComponent({
            open: true,
            type: 'error',
            message: `${error?.response?.data?.message}`,
          });
          // setIsConfirmModalOpen(false);
        })
        .finally(() => {
          setIsLoading(false);
        });

    }
  };
  const [isVendorChatBoxOpen, setIsVendorChatBoxOpen] = useState(false);
  const vendorChatBoxClick = (vendorId) => {
    setActiveChatVendorId(vendorId);
    setIsVendorChatBoxOpen(true); /** for chatbox open from vendor side */
  }

  const handleChatboxMinimize = () => {
    setIsVendorChatBoxOpen(false);
  };

  const userRole = UserObj?.role?.name;
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">

          <div className="listing_projectss_react_div_rodf">
            <p className="listing_rfq">
              <div class="div-details-center react_technical_vendordetail22">
                <button
                  onClick={() => navigate(-1)}
                  class=""
                  style={{
                    padding: "9px 16px",
                    marginRight: "11px",
                    fontSize: "18px",
                    background: "black",
                  }}
                >
                  <img
                    src={back}
                    alt="back-button"
                    style={{ paddingRight: "3px" }}
                  />{" "}
                  Back
                </button> </div> Technical Comparison
              <strong className="bidding_round_rfq">- Bidding Round 1</strong>
            </p>
            <div className="extend_evaluation">
              {/* <button
                className="vendor_btn vendor_maine_content2"
                href="#"
                fdprocessedid="k4yyb6"
              >
                Award Vendor
              </button> */}
              {userRole !== 'ENGINEER' &&
                <button
                  className="vendor_btn vendor_maine_content2"
                  fdprocessedid="31fkt"
                  onClick={onExtendValidity}
                >
                  Extend Validity
                </button>
              }
              {rfqDetails?.technicalEvaluationStatus !== 'Completed' && (
                <button
                  className="vendor_btn vendor_maine_content2"
                  onClick={onFinalizeEvaluationInit}
                >
                  Finalize Evaluation
                </button>
              )}


            </div>
          </div>
          <div class="header_lineitem">
            <span class={"header-tb"} >
              Header
            </span>

          </div>

          {/* Technical Evaluation */}

          <div className="row1_firstcommercial_bpdt_section_react_roq">
            <table className="table table-bordered tble-sty vendor_rfqdetail_technical_body_row2" style={{ tableLayout: 'fixed' }}>
              <thead>
                <tr className="line_time_rfq_project_detail_body">
                  <th className="boq_detail_technical_package_react" style={{ width: '32px' }}>No</th>
                  <th className="boq_detail_technical_package_react" style={{ width: '126px', textAlign: 'center' }}>BOQ</th>
                  <th className="boq_detail_technical_package_react">QTY</th>
                </tr>
              </thead>
              <tbody>

                {techEvaluationDetails?.boqs?.map((boqsEle, i) => <>
                  <tr>
                    <td className="">{i + 1}</td>
                    <td className="vendor_c_reacts_package_blocklist_trews">
                      <p>
                        {/* <b>{boqsEle?.description}</b> */}
                        <Tooltip title={boqsEle?.description}> <b>{formatFileName(boqsEle?.description)}</b></Tooltip>
                      </p>
                    </td>
                    <td>{boqsEle?.quantity}</td>
                  </tr>
                </>)}


                <tr>
                  <td className="vendor_f_react_body_list_detail"></td>
                  <td className="vendor_f_react_body_list_detail">
                    <h2 className="lets_total_reactdetail_blocklist_roundq">
                      Total
                    </h2>
                  </td>
                  <td className="vendor_f_react_body_list_detail">
                    <h2 className="lets_total_reactdetail_blocklist_roundq">
                      {techEvaluationDetails?.totalQuantity}
                    </h2>
                  </td>
                </tr>
                <tr className="custom-borders">
                  <td></td>
                  <td style={{ height: "63px" }} className="border-top border-bottom text-end">
                    <p className="tender_drawing_f">
                      <b>Tender Drawing</b>
                    </p>
                    <p className="tender_drawing_f">
                      <b style={{ fontSize: "13px" }}>Technical Specification</b>
                    </p>
                    <p className="tender_drawing_f">
                      <b></b>
                    </p>
                  </td>
                  <td></td>
                </tr>

                {/* <tr class="custom-borders">
                  <td class="border-top border-bottom text-end technical_soon_div_tdf_reacts">
                    <p className="tender_drawing_f">
                      <b>Payment Terms</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom text-end technical_soon_div_tdf_reacts"
                  >
                    <p className="tender_drawing_f">
                      <b>Liquidated Damages</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom text-end technical_soon_div_tdf_reacts"
                  >
                    <p className="tender_drawing_f">
                      <b>Over all LD cap</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom text-end technical_soon_div_tdf_reacts"
                  >
                    <p className="tender_drawing_f">
                      <b>Defect Liability Period</b>
                    </p>
                  </td>
                  <td></td>
                </tr>

                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom text-end technical_soon_div_tdf_reacts"
                  >
                    <p className="tender_drawing_f">
                      <b>Service Contract </b>
                    </p>
                  </td>
                  <td></td>
                </tr>

                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom text-end technical_soon_div_tdf_reacts"
                  >
                    <p className="tender_drawing_f">
                      <b>Warrenty</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom text-end technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <p className="tender_drawing_f">
                      <b>Capacity</b>
                    </p>
                  </td>
                  <td></td>
                </tr> */}
              </tbody>
            </table>
            <div className="react_row_table_technical_body">
              <table className="table table-bordered tble-sty vendor_rfqdetail_technical_body ">
                <thead>
                  <tr className="line_time_rfq_project_detail_body">
                    {techEvaluationDetails?.rfqVendors?.map((ele, i) => <>
                      <th className="lets_oty_listing_detail_r_line">
                        <div className="vendor_b_react_package_blocklist_body">
                          <p className="vendor_a_react_body_list">{ele?.vendorName}</p>
                          {/* <img src={vendor1Image} alt="" /> */}
                          <div>
                            {/* <span className="rank-trophy">{j+1}</span> */}
                            {/* <span onClick={() => setActiveChatVendorId(ele?.vendorId)}> */}
                            <span onClick={() => vendorChatBoxClick(ele?.vendorId)}>
                              <img className="msgIco-img" src={msgIco} alt="" />
                            </span>

                            <div>
                              <span className="rank-trophy">{i + 1}</span>
                              <span>
                                <img className="rank-trophy-img" src={trophyImage} alt="" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <p class="bidding_block_sky">{strToDate(ele?.updatedAt)}</p>
                      </th>
                    </>)}

                  </tr>
                </thead>
                <tbody>

                  {techEvaluationDetails?.boqs?.map((boqsEle, i) => <>
                    <tr>
                      {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                        <td>
                          <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">
                              <span class="bidding_block_rate ">XXXX</span>
                            </div>
                          </div>
                        </td>
                      </>)}
                    </tr>

                  </>)}


                  <tr>
                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td className="vendor_f_react_body_list_detail">
                        <div className="total_vendor_round_detail_panel_q">
                          <h2 className="lets_total_reactdetail_blocklist_roundq">
                            {rfqVendorsEle?.status}
                          </h2>
                        </div>
                      </td>
                    </>)}

                  </tr>
                  <tr className="custom-borders">
                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, i) => <>

                      <td>
                        <div className="lets_customs_div_reacts_round1">
                          <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">

                              {(rfqVendorsEle?.tendorDrawing?.length < 1) && <>
                                <p className="tender_drawing_f">N/A</p>
                              </>}

                              {rfqVendorsEle?.tendorDrawing?.map((attachmentEle, j) => <>{console.log("attachmentEle, j", attachmentEle, j)}
                                <p
                                  className="tender_drawing_f"
                                  onClick={() =>
                                    attachmentEle?.acknowledged
                                      ? downloadAttachment(
                                        attachmentEle?.key,
                                        attachmentEle?.fileName,
                                        "tendorDrawing",
                                        i,
                                        j
                                      )
                                      : downloadAttachment(
                                        attachmentEle?.vendorResponse?.key,
                                        attachmentEle?.vendorResponse?.fileName,
                                        "tendorDrawing",
                                        i,
                                        j
                                      )
                                  }
                                >
                                  {attachmentEle?.acknowledged === true ? (
                                    attachmentEle?.fileName
                                  ) : (
                                    attachmentEle?.vendorResponse?.fileName
                                  )}
                                  <img src={download1Image} alt="" />

                                  {rfqVendorsEle?.technicalStatus === "Approved" || rfqVendorsEle?.technicalStatus === "Rejected" ? (
                                    <input checked="checked" type="checkbox" />
                                  ) : (
                                    <input checked={attachmentEle?.isChecked} type="checkbox" />
                                  )}
                                </p>

                                {/* <p className="tender_drawing_f" onClick={() => downloadAttachment(attachmentEle?.key, attachmentEle?.fileName, "tendorDrawing", i, j)}>
                                  {attachmentEle?.fileName} <img src={download1Image} alt="" />

                                  {(rfqVendorsEle?.technicalStatus === "Approved" || rfqVendorsEle?.technicalStatus === "Rejected") ? (
                                    <input checked="checked" type="checkbox" />
                                  ) :

                                    <input checked={attachmentEle?.isChecked} type="checkbox" />
                                  }

                                </p> */}



                              </>)}

                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            {(rfqVendorsEle?.technicalSpecification?.length < 1) && <>
                              <p className="tender_drawing_f">N/A</p>
                            </>}

                            {rfqVendorsEle?.technicalSpecification?.map((attachmentEle, j) => <>
                              <p
                                className="tender_drawing_f"
                                onClick={() =>
                                  attachmentEle?.acknowledged
                                    ? downloadAttachment(
                                      attachmentEle?.key,
                                      attachmentEle?.fileName,
                                      "technicalSpecification",
                                      i,
                                      j
                                    )
                                    : downloadAttachment(
                                      attachmentEle?.vendorResponse?.key,
                                      attachmentEle?.vendorResponse?.fileName,
                                      "technicalSpecification",
                                      i,
                                      j
                                    )
                                }
                              >
                                {attachmentEle?.acknowledged === true ? (
                                  attachmentEle?.fileName
                                ) : (
                                  attachmentEle?.vendorResponse?.fileName
                                )}

                                <img src={download1Image} alt="" />

                                {rfqVendorsEle?.technicalStatus === "Approved" || rfqVendorsEle?.technicalStatus === "Rejected" ? (
                                  <input checked="checked" type="checkbox" />
                                ) : (
                                  <input checked={attachmentEle?.isChecked} type="checkbox" />
                                )}
                              </p>



                            </>)}
                          </div>
                        </div>
                        {(rfqVendorsEle?.technicalStatus == "Pending") && <div className="technidal_evaluation_reject_div_layout1">
                          <p onClick={() => onApproval("Approved", { index: i, vendorId: rfqVendorsEle?.vendorId, vendorName: rfqVendorsEle?.vendorName })}
                            className="vendor_approves">Approve</p>
                          <span>|</span>
                          <p onClick={() => onApproval("Rejected", { index: i, vendorId: rfqVendorsEle?.vendorId, vendorName: rfqVendorsEle?.vendorName })}
                            className="vendor_approve">Reject</p>
                        </div>}

                        {(rfqVendorsEle?.technicalStatus != "Pending") && <div className="technidal_evaluation_reject_div_layout1">
                          <span>{rfqVendorsEle?.technicalStatus}</span>
                        </div>}
                      </td >
                    </>)}

                  </tr>

                  {/* <tr class="custom-borders">

                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              -
                            </p>
                          </div>
                        </div>
                      </td>
                    </>)}
                    <td>
                      <div className="d-flex justify-content-between">
                      <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              Attachment <img src={download1Image} alt="" />
                            </p>
                          </div>
                      </div>
                    </td> 
                  </tr>
                  <tr class="custom-borders">

                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              -
                            </p>
                          </div>
                        </div>
                      </td>
                    </>)}

                    <td>
                      <div className="d-flex justify-content-between">
                      <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                             5%
                            </p>
                          </div>
                      </div>
                    </td> 
                  </tr>
                  <tr class="custom-borders">
                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              -
                            </p>
                          </div>
                        </div>
                      </td>
                    </>)}


                    <td>
                      <div className="d-flex justify-content-between">
                      <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              Attachment <img src={download1Image} alt="" />
                            </p>
                          </div>
                      </div>
                    </td>

                  </tr>
                  <tr class="custom-borders">
                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              -
                            </p>
                          </div>
                        </div>
                      </td>
                    </>)}
                    <td>
                      <div className="d-flex justify-content-between">
                      <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                             2 months
                            </p>
                          </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="custom-borders">
                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              -
                            </p>
                          </div>
                        </div>
                      </td>
                    </>)}

                    <td>
                      <div className="d-flex justify-content-between">
                      <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                             45 Days
                            </p>
                          </div>
                      </div>
                    </td>

                  </tr>
                  <tr class="custom-borders">
                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <p className="vendor_approve">
                              -
                            </p>
                          </div>
                        </div>
                      </td>
                    </>)}

                    <td>
                      <div className="d-flex justify-content-between">
                      <div className="evaluation_react_bvfdt_div_block1">
                            <p className="vendor_approve">
                       No
                            </p>
                          </div>
                      </div>
                    </td>

                  </tr>
                  <tr class="custom-borders">

                    {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              - 
                            </p>
                          </div>
                        </div>
                      </td>
                    </>)}


                    <td>
                      <div className="d-flex justify-content-between">
                      <div className="evaluation_react_bvfdt_div_block1">
                            <p className="tender_drawing_f">
                              Attachment <img src={download1Image} alt="" />
                            </p>
                          </div>
                      </div>
                    </td>

                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
          {/* Technical Evaluation Comment Section */}

          {/* <div class="comments_main">
            <h3>Comments</h3>
            <div class="comments_main_in">
              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input type="text" placeholder="Type comments..." />

                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="epy4fp"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="5izdv"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>
            </div>
          </div> */}

          {(techEvaluationDetails?.rfqVendors?.length > 0) && (
            <>
              {techEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, i) => <>
                <SupportChat
                  vendorDetails={{ vendor: { _id: rfqVendorsEle?.vendorId } }}
                  isComparison={true}
                  comparisonData={{
                    isActive: rfqVendorsEle?.vendorId == activeChatVendorId,
                    vendorName: rfqVendorsEle?.vendorName,
                    rfqId: id,
                    isVendorChatBoxOpen: isVendorChatBoxOpen,
                  }}
                  onMinimize={handleChatboxMinimize}
                />
              </>)}
            </>
          )}

          {/* Finalize Evaluation Modal  */}

          <Modal
            open={openfinalizeevaluation}
            onClose={() => setOpenFinalizeEvaluation(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Finalize Evaluation
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenFinalizeEvaluation(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <p>Do you want to finalize the Technical Evaluation?</p>
                    <div class="approved_block_rejected">
                      <h5>Approved : {finalizeObj?.approvedVendors?.length}</h5>
                      <h5>Rejected : {finalizeObj?.rejectedVendors?.length}</h5>
                    </div>
                    <div className="lets_no_btn_danger_yes_technical_project">
                      <button
                        onClick={() => {
                          setOpenFinalizeEvaluation(false);
                        }}
                        type="button"
                        class="btn btn btn-danger"
                      >
                        No
                      </button>
                      <button
                        // onClick={onFinalizeSubmit}
                        onClick={() => setShowFinalizeConfirmation(true)}
                        type="button"
                        class="btn btn-success"
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/* Finalize Evaluation sucessfully Modal  */}
          {showFinalizeConfirmation && (
            <Modal
              open={showFinalizeConfirmation}
              onClose={() => setShowFinalizeConfirmation(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">Confirm Finalization</h1>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => {
                      setShowFinalizeConfirmation(false);
                      setOpenFinalizeEvaluation(false);
                    }}
                  ></button>
                </div>
                <div className="modal-bodys">
                  <p>
                    You have invited <b>{techEvaluationDetails?.vendorsInvited} vendors. </b>
                    {techEvaluationDetails?.vendorsPending > 0 ? (
                      <>
                        <b>{techEvaluationDetails.vendorsPending} vendors</b> have not submitted yet.
                      </>
                    ) : (
                      'All vendors have submitted'
                    )}

                  </p>
                  <p> Do you wish to continue?</p>
                  <div className="clear_btn_status_modified_boq">
                    <button
                      type="button"
                      className="btn btn btn-danger"
                      onClick={() => {
                        setShowFinalizeConfirmation(false);
                        setOpenFinalizeEvaluation(false);
                      }}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={onFinalizeSubmit}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          )}
          <Modal
            open={openfinalizeevaluationsuccessfully}
            onClose={() => redirectToListing()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Finalize Technical Evaluation
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => redirectToListing()}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  {/* <h3 class="evaluation_block">
                    Finalize Technical Evaluation
                  </h3> */}
                  <div className="approvel_btn_successfully">
                    <p>
                      Technical Evaluation for this RFQ has been completed successfully. Respective Vendors & Buyer will be notified accordingly.
                    </p>

                    <div className="lets_no_btn_danger_yes_technical_project">
                      <button type="button" class="btn btn-success"
                        onClick={() => redirectToListing()}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/*  Approve Finalize Evaluation Modal  */}

          <Modal
            open={openapprovefinalize}
            onClose={() => setOpenApproveFinalize(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  {approvalObj?.param == "Approved" ? "Approve" : "Reject"}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenApproveFinalize(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <p>
                      This approval will {approvalObj?.param == "Approved" ? "Approve" : "Reject"}  the vendor from Technical
                      Comparison
                    </p>
                    <p>Do you want to continue?</p>

                    <div className="lets_no_btn_danger_yes_technical_project">
                      <button
                        onClick={() => {
                          setOpenApproveFinalize(false);
                          setApprovalObj({});
                        }}
                        type="button"
                        class="btn btn btn-danger"
                      >
                        No
                      </button>
                      <button
                        onClick={() => {
                          setOpenApproveFinalize(false);
                          setOpenVendoRattingTechnical(true);
                        }}
                        type="button"
                        class="btn btn-success"
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/*  Vendor A Rating Finalize Evaluation Modal  */}
          <Modal
            open={openvendorattingtechnical}
            onClose={() => setOpenVendoRattingTechnical(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  {approvalObj?.vendorData?.vendorName} Rating
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenVendoRattingTechnical(false)}
                ></button>
              </div>
              <div class="modal-body">
                <from>
                  <p>Please rate the Vendor based on Technical Evaluation.</p>
                  {/* <p className="lets_slider_evaluation_approve_btn_modal">
                    Drag the slider to a point on the scale.
                  </p> */}

                  <div className="approvel_btn_successfullys">
                    <Box
                      sx={{
                        "& > legend": { mt: 2 },
                      }}
                    >
                      <Rating
                        // defaultValue={approvalObj?.rating} 
                        name="rating"
                        onChange={onRatingChange}
                        value={approvalObj?.rating}
                        max={5}
                      />
                    </Box>
                  </div>
                  <div class="Newvendor_category">
                    <label class="mb-1 text-dark">
                      Feedback/Remarks
                      <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="feedbackInput"
                      class="form-control form_h_modal"
                      placeholder="Enter your feedback or remarks"
                      name="feedback"
                      value={approvalObj?.feedback}
                      onChange={onRatingChange}
                      required=""
                      fdprocessedid="bztnki"
                    />
                    <div class="error-message" id="feedbackError"></div>
                  </div>
                  <div class="approve_button justify-content-end mt-3">
                    {approvalObj?.param == "Approved" && <button
                      onClick={() => {
                        onRatingSubmit();
                      }}
                      class="btn btn-success"
                    >
                      Approve
                    </button>}
                    {approvalObj?.param == "Rejected" && <button
                      onClick={() => {
                        onRatingSubmit();
                      }}
                      class="btn btn-success"
                    >
                      Reject
                    </button>}
                    <button
                      onClick={() => {
                        setOpenVendoRattingTechnical(false);
                      }}
                      class="btn btn-danger"
                    >
                      Close
                    </button>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/* Vendor Approved Succesfully Modal */}
          <Modal
            open={openvendorsuccessfullytechnical}
            onClose={() => {
              setOpenVendorSuccessfullyTechnical(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => {
                    setOpenVendorSuccessfullyTechnical(false);
                  }}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <img src={checkImage} alt="" />
                    <p>
                      {approvalObj?.vendorData?.vendorName}  has been {approvalObj?.param == "Approved" ? "approved" : "rejected"}  successfully for
                      <br /> Technical Evaluation.
                    </p>
                    <p></p>
                    <button
                      onClick={() => {
                        setApprovalObj({});
                        setOpenVendorSuccessfullyTechnical(false);
                      }}
                      type="button"
                      class="btn btn-success save_next_btn"
                    >
                      Done
                    </button>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
        </div>
      </div >

      <RfqExtendValidaityModal
        setOpnExtendValidtyModal={setOpnExtendValidtyModal}
        opnextendvalidtymodal={opnextendvalidtymodal}
        rfqNumber={rfqNumber}
        currentRfqValidity={currentRfqValidity}
        handleNewDatePickerChange={handleNewDatePickerChange}
        newValidityPeriod={newValidityPeriod}
        closeExtendValidty={closeExtendValidty}
        handleSubmit={handleSubmit}
        currentValidityPeriod={currentValidityPeriod}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default EvaluationTechnical;
